// maine bounds with little buffer around
// [sw.lng, sw.lat, ne.lng, ne.lat]
const startingBounds = [-71.6, 42.6, -66.5, 47.8];

const maxBounds = [-80.6, 37.6, -58.5, 52.8];


const basemapStyles = [
	{"style": "Light",
	 "url": "https://api.maptiler.com/maps/basic-v2-light/style.json?key=GgAB2Lm1bPAxmy2SEkiu"},
	{"style": "Satellite",
	 "url": "https://api.maptiler.com/maps/hybrid-v4/style.json?key=GgAB2Lm1bPAxmy2SEkiu"}
];

module.exports = {
	startingBounds,
	maxBounds,
	basemapStyles
}